export default {
      id: "left-caret-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#left-caret",
      toString: function () {
        return this.url;
      }
    }